module.exports = __webpack_public_path__ + "static/media/ic_close.cad77b9a.svg";